import { css } from 'linaria';

export const deliniaSection = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 24px 40px;
  padding-right: 56px;
  background: var(--background-secondary);
  border-radius: var(--rounding-l);

  @media (--only-desktop) {
    flex-direction: column;
    justify-content: flex-start;
    padding-right: 40px;
  }

  @media (--only-tablet) {
    padding-right: 40px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    justify-content: flex-start;
    padding: 16px;
  }
`;

export const deliniaLogo = css`
  width: 117px;
  height: 64px;

  @media (--to-desktop) {
    width: 91px;
    height: 50px;
  }

  @media (--only-desktop) {
    margin-bottom: 16px;
  }

  @media (--only-mobile) {
    width: 82px;
    height: 45px;
    margin-bottom: 16px;
  }
`;

export const deliniaContent = css`
  width: 885px;

  @media (--only-desktop) {
    width: 100%;
  }

  @media (--only-tablet) {
    width: 440px;
  }

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const deliniaContentTitle = css`
  && {
    @media (--to-desktop) {
      margin-bottom: 8px;
    }

    @media (--to-desktop) {
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const deliniaContentText = css`
  && {
    margin-bottom: 24px;

    @media (--to-desktop) {
      margin-bottom: 16px;
      font-size: 14px;
      line-height: 18px;
    }
  }
`;

export const deliniaContentList = css`
  && {
    @media (--from-desktop) {
      display: flex;
      justify-content: space-between;
      padding: 0;
      list-style: none;
      row-gap: 50px;
    }

    li {
      margin-bottom: 0;
      @media (--to-desktop) {
        margin-bottom: 4px;

        :last-of-type {
          margin-bottom: 0;
        }

        span {
          font-size: 14px;
          line-height: 18px;
        }
      }

      @media (--only-mobile) {
        margin-bottom: 8px;

        :last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }
`;
